import {ReportInfo} from '../../store/reports';

export class PollingResult {
    constructor(public data?: ReportInfo, public error?: string) {
    }
}
